import type { TOC } from '@ember/component/template-only';
import { PhWarning } from 'ember-phosphor-icons';
import { t } from 'ember-intl';

export interface NoDetailsArgs {
  Element: HTMLElement;
}

const NoDetails: TOC<NoDetailsArgs> = <template>
  <div class="tio-row-flush m-4">
    <div class="tio-row-center w-12 h-12 mr-[10px] rounded-full tio-bg-neutral">
      <div class="h-6 tio-fg-inverse">
        <PhWarning @size="32" @weight="fill" />
      </div>
    </div>
    <div class="tio-fg-disabled">
      {{t "common.progress_tracker.no_details"}}
    </div>
  </div>
</template>;

export default NoDetails;
